import React from 'react';
import firstLetterToUpperCase from '../../shared/firstLetterToUpperCase';

// Styled Components
import {
  Container,
  Header,
  Author,
  ViewsDetails,
  CreationDate,
  Text,
} from './styles';


export default function ManagerNotificationItem({
  author,
  viewsDetails,
  creationDate,
  text,
  onItemClick,
}) {
  return (
    <Container onClick={onItemClick}>
      <Header>
        <Author>{firstLetterToUpperCase(author)}</Author>
        <ViewsDetails>{viewsDetails}</ViewsDetails>
        <CreationDate variant="caption">{creationDate}</CreationDate>
      </Header>
      <Text>{text}</Text>
    </Container>
  );
}
